import type { JSX } from 'react';
import { AvisoInactividad } from './auth/AvisoInactividad';
import { BannerModoConsulta } from './components/BannerModoConsulta';
import { OfflineBanner } from './components/OfflineBanner';
import { SelectorEspecialidadDemo } from './components/SelectorEspecialidadDemo';
import { TooltipProvider } from './components/ui/tooltip';
import { Toaster } from './components/ui/sonner';
import { AvisosSala } from './dashboard/AvisosSala';
import { AvisoTelemedicina } from './dashboard/AvisoTelemedicina';
import { AlertaCompletitudPopup } from './paciente/AlertaCompletitudPopup';
import { AppRoutes } from './routes';

export function App(): JSX.Element {
  return (
    <TooltipProvider delayDuration={200}>
      <BannerModoConsulta />
      <OfflineBanner />
      <Toaster />
      <SelectorEspecialidadDemo />
      {/* Hermano de <AppRoutes/>, no hijo — así el popup de completitud (se
          dispara al SALIR de la ficha de un paciente, ver el useEffect de
          PatientChartPage.tsx) sobrevive a la navegación que lo disparó. */}
      <AlertaCompletitudPopup />
      {/* Contador de pacientes en espera y aviso «Paciente X llegó» de la Sala: visibles desde cualquier pantalla. */}
      <AvisosSala />
      {/* Tarjeta con sonido 5 min antes de una videollamada (citas virtuales del médico): también desde cualquier pantalla. */}
      <AvisoTelemedicina />
      {/* Aviso de cierre por inactividad (MT-047): solo con sesión de Medplum abierta. */}
      <AvisoInactividad />
      <AppRoutes />
    </TooltipProvider>
  );
}
